module.exports = {
	"id": "VA",
	"name": "Holy See (Vatican City State)",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.009088,
			"22": 0.09088,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.04544,
			"28": null,
			"29": null,
			"30": 0.009088,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.109056,
			"35": 0.009088,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.054528,
			"41": 0.009088,
			"42": null,
			"43": 0.163584,
			"44": 0.009088,
			"45": null,
			"46": null,
			"47": 0.009088,
			"48": 0.009088,
			"49": 2.880896,
			"50": 0.036352,
			"51": null,
			"52": 0.18176,
			"53": 27.109504,
			"54": 5.81632,
			"55": 0.04544,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.063616,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.672512,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.018176,
			"36": 0.345344,
			"37": null,
			"38": null,
			"39": 0.054528,
			"40": null,
			"41": 0.009088,
			"42": 0.118144,
			"43": 0.109056,
			"44": null,
			"45": null,
			"46": 0.172672,
			"47": 0.263552,
			"48": 0.890624,
			"49": 15.894912,
			"50": 0.009088,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.009088
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.009088,
			"38": null,
			"39": null,
			"40": 0.099968,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.018176
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.099968,
			"6": null,
			"7": 0.018176,
			"8": 0.081792,
			"9": 0.2272,
			"10": 2.31744,
			"3.1": null,
			"3.2": null,
			"5.1": 0.95424,
			"6.1": 0.018176,
			"7.1": null,
			"9.1": 0.645248
		},
		"ios_saf": {
			"8": 0,
			"10": 1.93416047211,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.052123386657,
			"8.1-8.4": 0.0962957482306,
			"9.0-9.2": 0.0459392560366,
			"9.3": 0.700868136969
		},
		"android": {
			"3": 0,
			"4": 0.00708459689922,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.000885574612403,
			"4.1": 0.0255551531008,
			"4.2-4.3": 0.0638878827519,
			"4.4": 0.146499343023,
			"4.4.3-4.4.4": 0.147764449612
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.345344,
			"9": 0.399872,
			"10": 0.354432,
			"11": 26.455168,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00176296106276,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0000489711406322
		},
		"edge": {
			"12": 0.190848,
			"13": 0.899712,
			"14": 2.126592
		},
		"ie_mob": {
			"10": 0.0279043661972,
			"11": 0.113610633803
		},
		"bb": {
			"7": 0.00159775,
			"10": null
		},
		"samsung": {
			"0": 0.609884
		},
		"and_uc": {
			"0": null
		},
		"op_mini": {
			"0": 0.0237520677966
		},
		"and_chr": {
			"0": 4.781958
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 99.27079875
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/VA.json
 ** module id = 675
 ** module chunks = 0
 **/